import { useEffect, useState } from "react";
import { ClipLoader } from 'react-spinners'

// TODO: handle html structure for FLC

/* eslint-disable jsx-a11y/anchor-is-valid */
function LogoContainer(props: any) {
    let colClass = "col-lg-3"
    if (props.showTwoColumns === "True") {
        colClass = "col-lg-6"
    }
    const [showLoader, setShowLoader] = useState(false)

    useEffect(() => {
        setShowLoader(true)
    }, [props.src])

    const onImgLoad = () => {
        setShowLoader(false)
    }

    return (
        <div className={`${colClass} margin-bottom-25`} style={{
            display: props.isLoaded ? 'block' : 'none'
        }}>
            <div className="logo-gallery--item">
                {showLoader && <div className="imgLoaderWrapper">
                    <ClipLoader color="#533E89" />
                </div>}
                <div>
                    <div className="logo-gallery--item__img">
                        <a>
                            <span className="loader-item" style={{
                                backgroundColor: "#fff"
                            }}>
                                <img style={{
                                    width: "100%",
                                    cursor: "pointer"
                                }}
                                    onClick={props.onClick}
                                    className="img-responsive"
                                    src={props.src}
                                    alt="some logo"
                                    onLoad={onImgLoad}
                                    loading="lazy"
                                />
                            </span>
                        </a>
                    </div>

                    <div className="logo-gallery--item__controls">
                        <a data-linkname="Logo Click" onClick={props.onClick} className="btn btn-primary btn-customize select-btn">Select</a>
                    </div>

                </div>
            </div>
        </div>);
}

export default LogoContainer




